/**
 * RFC 7807 problem `type` URIs for shortlist business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Order\Enum\ShortlistErrorType`.
 */
export const ShortlistErrorType = {
  MissingOrder: '/errors/shortlist-missing-order',
  MissingApplicants: '/errors/shortlist-missing-applicants',
  ApplicantRecipient: '/errors/shortlist-applicant-recipient',
  CopiedRecipients: '/errors/shortlist-copied-recipients'
} as const

export type ShortlistErrorType =
  (typeof ShortlistErrorType)[keyof typeof ShortlistErrorType]
